<template>
  <div class="modal-overflow" v-if="show">
    <div class="modal-box">
      <div @click="close" v-if="closeButton">
        <p>CLOSE</p>
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    show: Boolean,
    closeButton: false
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
